module.exports = __webpack_public_path__ + "static/media/notFoundCharacterSerios.3103cb30.svg";